import React from "react";

import classNames from "classnames";
import dayjs from "dayjs";

import { Modal, Typography } from "clearsense-ui/components";
import { getTimeAndDate } from "utils/date";

const Details = ({ whatIfDetails, metadata }) => {
  const getRunDate = runDate => {
    const convertedDate = dayjs.unix(runDate);
    const { date, time } = getTimeAndDate(convertedDate);
    return `${date} ${time}`;
  };

  return (
    <>
      <Modal.Header className="flex justify-between items-center">
        <Typography style="h3" type="bold">
          {metadata?.name}
        </Typography>
        <Typography style="large">{getRunDate(metadata?.runDate)}</Typography>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-4">
          <div
            className={classNames(
              "flex-none px-6 py-4",
              whatIfDetails?.targetRate?.change > 0
                ? "bg-green-300"
                : "bg-red-300"
            )}
          >
            <Typography style="h3" type="semibold" className="text-center">
              Target Rate Change (pp){" "}
              {whatIfDetails?.targetRate?.change > 0
                ? `+${whatIfDetails?.targetRate?.change}`
                : whatIfDetails?.targetRate?.change}
            </Typography>
          </div>
          <div className="space-y-3 overflow-y-auto max-h-72">
            {whatIfDetails?.adjustments?.map(
              ({ change, columnName, value }) => (
                <div
                  key={columnName}
                  className="space-y-2 border-2 rounded p-2"
                >
                  <div className="space-x-2 flex">
                    <Typography style="h4">Column :</Typography>
                    <Typography style="h4" type="semibold">
                      {columnName}
                    </Typography>
                  </div>
                  <div className="space-x-2 flex">
                    <Typography style="h4">with value :</Typography>
                    <Typography style="h4" type="semibold">
                      {value}
                    </Typography>
                    <Typography style="h4">changed by :</Typography>
                    <Typography style="h4" type="semibold">
                      {change}
                    </Typography>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default Details;
